module.exports = imageCompression;